import { render, staticRenderFns } from "./DocumentTagFormDialog.vue?vue&type=template&id=7a3f77fe&"
import script from "./DocumentTagFormDialog.vue?vue&type=script&lang=ts&"
export * from "./DocumentTagFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports